<template>
    <v-menu left offset-y min-width="140">
            <template v-slot:activator="{ on }">

                <v-btn
                  class="px-1 button-text secondary--text text--lighten-1 subtitle-2 font-weight-medium"
                  height="40"
                  v-on="on"
                  text
                >
                  <v-icon class="mr-2">mdi-export-variant</v-icon>
                  <span class="hidden-sm-and-down">Exportar o gráfico</span>
                  <span class="hidden-md-and-up">Exportar</span>
                </v-btn>

            </template>

            <v-list class="py-4">
                <v-list-item v-if="!(disableItems.length > 0 && disableItems.includes('FULLSCREEN'))" link @click="fullscreenChart()" class="hidden-xs-only">
                    <v-list-item-icon class="mr-1">
                        <v-icon class="secondary--text text--lighten-1">mdi-fullscreen</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content class="secondary--text text--lighten-1">
                        <span>Visualizar em tela cheia</span>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="!(disableItems.length > 0 && disableItems.includes('PRINT'))" link @click="printChart()">
                    <v-list-item-icon class="mr-1">
                        <v-icon class="secondary--text text--lighten-1">mdi-printer</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content class="secondary--text text--lighten-1">
                        <span>Imprimir gráfico</span>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="!(disableItems.length > 0 && disableItems.includes('PNG'))" link @click="exportChart('image/png')">
                    <v-list-item-icon class="mr-1">
                        <v-icon class="secondary--text text--lighten-1">mdi-image-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content class="secondary--text text--lighten-1">
                        <span>Baixar imagem PNG</span>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="!(disableItems.length > 0 && disableItems.includes('JPEG'))" link @click="exportChart('image/jpeg')">
                    <v-list-item-icon class="mr-1">
                        <v-icon class="secondary--text text--lighten-1">mdi-image-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content class="secondary--text text--lighten-1">
                        <span>Baixar imagem JPEG</span>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="!(disableItems.length > 0 && disableItems.includes('SVG'))" link @click="exportChart('image/svg+xml')">
                    <v-list-item-icon class="mr-1">
                        <v-icon class="secondary--text text--lighten-1">mdi-vector-square</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content class="secondary--text text--lighten-1">
                        <span>Baixar imagem SVG</span>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="!(disableItems.length > 0 && disableItems.includes('PDF'))" link @click="exportChart('application/pdf')">
                    <v-list-item-icon class="mr-1">
                        <v-icon class="secondary--text text--lighten-1">mdi-file-document-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content class="secondary--text text--lighten-1">
                        <span>Baixar documento PDF</span>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="!(disableItems.length > 0 && disableItems.includes('CSV'))" link @click="exportCSV">
                    <v-list-item-icon class="mr-1">
                        <v-icon class="secondary--text text--lighten-1">mdi-file-table-box-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content class="secondary--text text--lighten-1">
                        <span>Baixar documento CSV</span>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="!(disableItems.length > 0 && disableItems.includes('XLS'))" link @click="exportXLS">
                    <v-list-item-icon class="mr-1">
                        <v-icon class="secondary--text text--lighten-1">mdi-file-table-box-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content class="secondary--text text--lighten-1">
                        <span>Baixar documento XLS</span>
                    </v-list-item-content>
                </v-list-item>
           </v-list>

        </v-menu>
</template>

<script>
export default {
    name: 'ChartExportMenu',
    props:{        
        disableItems:{
            type: Array,
            default: () => []
        }
    },
    data:()=>({
    }),
    methods:{
        fullscreenChart(){
            this.$emit('fullscreenChart');
        },
        printChart(){
            this.$emit('printChart');
        },
        exportChart(type){
            this.$emit('exportChart', type);
        },
        exportCSV(){
            this.$emit('exportCSV');
        },
        exportXLS(){
            this.$emit('exportXLS');
        }
    }
}
</script>

<style>

</style>
